import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { ApiService } from '../../core/services/api.service';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { ContentDataStoreService, INotificationsCountInfo } from './content-data-store.service';
import { AuthState } from '../../shared/models/auth/auth-state.model';

@Injectable({
  providedIn: 'root',
})
export class ContentDataService {
  public hidden = false;

  constructor(private api: ApiService,
              private contentDataStoreService: ContentDataStoreService,
              private authStoreService: AuthStoreService) {
    this.init();
  }

  public init() {
    this.refresh();
  }

  public refresh() {
    if (this.authStoreService.state !== AuthState.NOT_AUTHENTICATED && this.authStoreService.userInfo !== null) {
      this.getData<INotificationsCountInfo>(
        `/customers/${this.authStoreService.userInfo.customer_id}/notificationsCountInfo`,
        [
          'notifications-count-info/urgent-liabilities',
          'notifications-count-info/customer-biller-notifications',
          'notifications-count-info/not-seen-offers',
        ],
      ).subscribe(value => this.contentDataStoreService.setState(value));
    }
  }

  public refreshDefermentsState(overdueDeferments: number) {
    let { state } = this.contentDataStoreService;
    state.overdueDeferments = overdueDeferments;
    this.contentDataStoreService.setState(state);
  }

  private getData<T>(path: string, urls: string[]): Observable<T> {
    return combineLatest([
      this.api.fetch<T>(path).pipe(shareReplay({ bufferSize: 1, refCount: true })),
      this.api.subscribe<T>(urls[0]).pipe(startWith(null as string)),
      this.api.subscribe<T>(urls[1]).pipe(startWith(null as string)),
      this.api.subscribe<T>(urls[2]).pipe(startWith(null as string)),
    ]).pipe(map(this.matcher));
  }

  private matcher = ([data, urgentLiabilitiesCount, customerBillerNotificationsCount, notSeenOffersCount]) => {
    if (urgentLiabilitiesCount !== null && urgentLiabilitiesCount >= 0) {
      return { ...data, urgentLiabilitiesCount };
    }
    if (customerBillerNotificationsCount !== null && customerBillerNotificationsCount >= 0) {
      return { ...data, customerBillerNotificationsCount };
    }
    if (notSeenOffersCount !== null && notSeenOffersCount >= 0) {
      return { ...data, notSeenOffersCount };
    }
    return data;
  };

  public hideCustomerBillersNotification(): void {
    this.hidden = true;
  }

  public showCustomerBillersNotification(): void {
    this.hidden = false;
  }

  public clear() {
    this.contentDataStoreService.clear();
  }

}
